const TimeDisplay = (data) => {
  const getTimeFromDatetime = (data) => {
    const primeiroHospital = Object.entries(data)[0];
    let dataExtracao;
    if (primeiroHospital != undefined) {
      const primeiraEspecialidade = Object.entries(primeiroHospital[1])[0];
      dataExtracao = primeiraEspecialidade[1][0].data_extracao;
    }
    if (dataExtracao) {
      const date = new Date(dataExtracao);

      const timeString = date.toLocaleTimeString();
      const dateString = date.toLocaleDateString();
      return `${dateString} - ${timeString}`;
    } else {
      return "";
    }
  };

  return getTimeFromDatetime(data);
};

export default TimeDisplay;
